/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Locale
 */

"use strict";

// Hard code this for now.
var Locale = {
  isRTL: function()  {return false;},
  getDirection: function()  {return 'LTR';}
};

module.exports = Locale;



/*****************
 ** WEBPACK FOOTER
 ** ./~/fixed-data-table/internal/Locale.js
 ** module id = 529
 ** module chunks = 0
 **/